import { render } from "./TheFooter.vue?vue&type=template&id=08d81ec0&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=08d81ec0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08d81ec0"

export default script